// A scroll event will only be triggered when there is a value of at least 1px change
export var minScroll = 1;
export var vertical = {
  direction: 'vertical',
  start: 'top',
  end: 'bottom',
  size: 'height',
  scrollAxis: 'scrollTop'
};
export var horizontal = {
  direction: 'horizontal',
  start: 'left',
  end: 'right',
  size: 'width',
  scrollAxis: 'scrollLeft'
};
export var defaultAllowedAxis = [horizontal.direction, vertical.direction];